import { __assign, __decorate, __extends, __rest } from "tslib";
import * as React from 'react';
import ModalPortal from './ModalPortal';
import { Misc, Utils } from '@singularsystems/neo-core';
import Button from '../Button';
import { Settings } from '@singularsystems/neo-core/dist/Settings';
import { Neo } from '../..';
import { observer } from 'mobx-react';
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.visible = false;
        _this.hasUnmounted = false;
        return _this;
    }
    Modal.prototype.componentWillUnmount = function () {
        this.hasUnmounted = true;
    };
    Modal.prototype.render = function () {
        var _this = this;
        var _a = this.props, closeButton = _a.closeButton, acceptButton = _a.acceptButton, buttons = _a.buttons, showCancelButton = _a.showCancelButton, title = _a.title, size = _a.size, formProps = _a.formProps, suppressForm = _a.suppressForm, className = _a.className, footer = _a.footer, footerContent = _a.footerContent, other = __rest(_a, ["closeButton", "acceptButton", "buttons", "showCancelButton", "title", "size", "formProps", "suppressForm", "className", "footer", "footerContent"]);
        var renderOnCollapse = false;
        var onClose;
        var show;
        var propertyInstance = this.props.bind;
        if (!propertyInstance) {
            propertyInstance = this.props.bindModel;
            if (propertyInstance) {
                renderOnCollapse = true;
            }
        }
        if (propertyInstance) {
            if (propertyInstance.value) {
                this.lastBindValue = propertyInstance.value;
            }
            if (typeof propertyInstance.value === "object") {
                formProps = formProps !== null && formProps !== void 0 ? formProps : {};
                if (!formProps.model) {
                    formProps.model = propertyInstance.value;
                }
            }
            show = !!propertyInstance.value;
            onClose = function (event) {
                if (propertyInstance.value === true) {
                    propertyInstance.value = false;
                }
                else {
                    propertyInstance.value = null;
                }
                if (_this.props.onClose) {
                    _this.props.onClose(event);
                }
            };
        }
        else {
            var manualProps = this.props;
            show = manualProps.show;
            onClose = manualProps.onClose;
        }
        if (show) {
            this.visible = true;
        }
        else {
            if (this.visible) {
                // Fade out
                if (!this.closeTimer) {
                    this.closeTimer = setTimeout(function () {
                        if (!_this.hasUnmounted) {
                            _this.visible = false;
                            _this.forceUpdate();
                        }
                        if (_this.props.afterClose) {
                            _this.props.afterClose();
                        }
                        ;
                        _this.closeTimer = null;
                    }, Misc.Settings.modalAnimationTimeMs);
                }
            }
        }
        if (!buttons) {
            buttons = [];
            if (acceptButton) {
                acceptButton = Utils.populatePartialWithDefaults(acceptButton, __assign({}, Settings.modal.acceptButton));
                buttons.push(acceptButton);
                if (!suppressForm) {
                    if (!this.onSubmit) {
                        this.onSubmit = acceptButton.onClick || onClose;
                    }
                    acceptButton.onClick = undefined;
                    acceptButton.isSubmit = true;
                }
            }
            else {
                suppressForm = true;
            }
            if (closeButton === undefined) {
                closeButton = {};
            }
            if (closeButton) {
                buttons.push(Utils.populatePartialWithDefaults(closeButton, __assign(__assign({}, Settings.modal.closeButton), { onClick: onClose })));
            }
        }
        var content = this.visible && React.createElement(React.Fragment, null,
            React.createElement("div", { className: "modal-body" }, this.props.children instanceof Function ? (show ? this.props.children(this.lastBindValue) : (renderOnCollapse ? this.props.children(this.lastBindValue) : undefined)) : this.props.children),
            React.createElement("div", { className: "modal-footer" }, footer ? footer : React.createElement(React.Fragment, null,
                footerContent && React.createElement("div", { className: "modal-footer-content" }, footerContent),
                buttons.map(function (buttonProps, index) { return React.createElement(Button, __assign({ key: index }, buttonProps)); }))));
        var container;
        if (suppressForm) {
            container = React.createElement(React.Fragment, null, content);
        }
        else {
            container = React.createElement(Neo.Form, __assign({}, formProps, { onSubmit: function (e) { _this.onSubmit && _this.onSubmit(e); } }), content);
        }
        return (this.visible &&
            React.createElement(ModalPortal, { show: show, onDismiss: onClose, options: this.props },
                React.createElement("div", { className: "modal-dialog" + (size ? " modal-" + size : "") + (className ? " " + className : "") },
                    React.createElement("div", { className: "modal-content" },
                        React.createElement("div", { className: "modal-header" },
                            React.createElement("h5", { className: "modal-title" }, this.props.title),
                            this.props.showCancelButton !== false &&
                                React.createElement("button", { type: "button", className: "close", "aria-label": "Close", onClick: onClose },
                                    React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
                        container))));
    };
    Modal = __decorate([
        observer
    ], Modal);
    return Modal;
}(React.Component));
export default Modal;
